/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'confluence.error.panel.refresh.app': 'Actualizar aplicación',
  'confluence.error.panel.reload.page': 'Recargar página',
  'confluence.icon.label': 'Icono',
  'confluence.modal.dialog.close.modal.button': 'Cancelar',
  'confluence.select.required.field.message': 'Este campo es obligatorio.',
  'confluence.text.area.required.field.message': 'Este campo es obligatorio.',
  'confluence.textfield.validator.email': 'Introduce un correo electrónico válido.',
  'confluence.textfield.validator.number': 'Introduce un número válido.',
  'confluence.textfield.validator.required.field.message': 'Este campo es obligatorio.',
  'confluence.textfield.validator.telephone': 'Introduce un número de teléfono válido.',
  'confluence.threeLOPrompt.modal.access.required.title': 'Acceso obligatorio',
  'confluence.threeLOPrompt.modal.error.title': 'Error',
  'confluence.threeLOPrompt.modal.no.authURL.error-message':
    'No se ha encontrado la URL de consentimiento. Actualiza la página y vuelve a intentarlo.',
  'confluence.threeLOPrompt.no.authURL.error-message':
    'No se ha encontrado la URL de consentimiento. Actualiza la página y vuelve a intentarlo.',
  'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Permitir acceso',
  'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Configurar acceso',
  'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': 'Se ha producido un error al autenticar.',
  'confluence.threeLOPrompt.use-auth.default.prompt.message':
    'Para que se muestre {appString}, debes permitir que la aplicación acceda a los productos de Atlassian en tu nombre.',
  'confluence.threeLOPrompt.use-auth.external.auth.prompt.message':
    '{appString} requiere un acceso adicional a tu cuenta.',
  'confluence.threeLOPrompt.use-auth.external.auth.warning.message': 'Advertencia de autenticación externa',
  'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'esta aplicación',
  'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Esta aplicación',
  'confluence.user.group.unknown.user.message': 'Usuario desconocido',
  'confluence.user.picker.empty.field.error.message': 'Este campo es obligatorio.',
  'confluence.user.unknown.user.message': 'Usuario desconocido',
  'forge-ui.form.submit-button.text': 'Enviar',
};
